import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { ConciergeModalSucessComponent } from '../../../modal-sucess/modal-success.component'
import { HttpErrorResponse } from '@angular/common/http'
import { GenericErrorComponent } from '../../../../../simple-bottom-sheets/generic-error.component'
import { ConciergeCancelReservationService } from './cancel-reservation.service'
import { LoadingPageComponent } from '@monorepo-channels/components/ui-pm'

@Component({
	standalone: true,
	selector: 'feature-pm-concierge-cancel-reservation-content',
	templateUrl: './cancel-reservation.component.html',
	styleUrls: ['./cancel-reservation.component.scss'],
	imports: [CommonModule, MatIconModule, MatButtonModule, LoadingPageComponent],
})
export class ConciergeCancelReservationComponent {
	private bottomSheet = inject(MatBottomSheet)
	private dialogRef = inject(MatDialogRef<ConciergeCancelReservationComponent>)
	public order = inject(MAT_DIALOG_DATA)
	private dialog = inject(MatDialog)
	private cancelReservationService = inject(ConciergeCancelReservationService)
	isLoading = false

	closeModal() {
		this.dialogRef.close()
	}

	cancelReservation() {
		this.isLoading = true
		this.cancelReservationService.cancelReservation(this.order).subscribe({
			next: () => {
				this.isLoading = false
				this.dialog.open(ConciergeModalSucessComponent, { data: 'Reserva cancelada!' })
				this.dialogRef.close('updated')
			},
			error: (err: HttpErrorResponse) => {
				const errorMessage = err.error?.message || 'Erro desconhecido'
				this.bottomSheet.open(GenericErrorComponent, {
					data: {
						error: errorMessage,
						title: 'Erro ao cancelar reserva',
						btnMessage: 'Fechar',
					},
				})
			},
		})
	}
}
